import { type fieldSchemaDefV1 } from '../../common/fieldSchemaDef';
import { z } from 'zod';

export const buildAttributeSchema = (
  fields: z.infer<typeof fieldSchemaDefV1.shape.fields>,
) => {
  return z.object(
    Object.fromEntries(
      fields.map((field) => {
        let rule = z.string();
        if (field.required) {
          rule = rule.trim().min(1, `${field.name} is required`);
        }

        return [field.id, rule];
      }),
    ),
  );
};
